// // import { createBrowserHistory } from 'history';

// // export const history = createBrowserHistory();

// import React,{Component} from 'react'
// import {
//   useHistory
// } from "react-router-dom";

// // export const history = useHistory()

// export default class history extends Component {
//     render(){
//         let history = useHistory();
//         return(
//             history
//         )
//     }
// }

import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();




